import React from "react";
import { newIcon } from "../Icon";

export const RightArrowIcon = newIcon(
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4772_52684)" filter="url(#filter0_d_4772_52684)">
      <path
        d="M14 18L19 13L14 8"
        stroke="#FFF"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 13L18 13"
        stroke="#FFF"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4772_52684"
        x="-1"
        y="-1"
        width="28"
        height="28"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.19 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4772_52684"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4772_52684"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_4772_52684">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(5 21) rotate(-90)"
        />
      </clipPath>
    </defs>
  </svg>,
  true
);
